import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable Modal component
 * Replaces 8+ duplicate modal implementations
 */
const Modal = ({ title, onClose, children, size = 'medium' }) => {
  const sizeStyle = {
    small: { maxWidth: '400px' },
    medium: { maxWidth: '600px' },
    large: { maxWidth: '800px' },
  }[size];

  return (
    <div className="modal-overlay">
      <div 
        className="modal" 
        style={sizeStyle}
      >
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
};

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

/**
 * Modal Body component
 */
export const ModalBody = ({ children }) => {
  return <div className="modal-body">{children}</div>;
};

ModalBody.propTypes = {
  children: PropTypes.node.isRequired,
};

/**
 * Modal Footer component
 */
export const ModalFooter = ({ children }) => {
  return <div className="modal-footer">{children}</div>;
};

ModalFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

Modal.Body = ModalBody;
Modal.Footer = ModalFooter;

export default Modal;
